
import { motion } from 'framer-motion';

export default function LoadingScreen() {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#0a0a0a]"
    >
      <motion.div
        initial={{ scale: 1, opacity: 1 }}
        animate={{ 
          scale: [1, 1.2, 0],
          opacity: [1, 1, 0]
        }}
        transition={{ duration: 2, ease: "easeInOut" }}
        className="relative"
      >
        <img 
          src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/34de0253fd17802be692fff692668476.png"
          alt="3DCARS.JP"
          className="w-32 h-32 object-contain"
        />
        <motion.div
          animate={{
            scale: [1, 1.5, 2],
            opacity: [0.8, 0.4, 0]
          }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute inset-0 rounded-full bg-[#00d4ff] blur-xl"
        />
      </motion.div>
    </motion.div>
  );
}
